import { useContext } from 'react';
import { Box } from '@mui/material';
import Analytics from '@siteplus/analytics';
import { AppContext } from '../context/AppContext';
import { useAnalytics } from '../services/analytics/hooks/useAnalytics';

const AnalyticsPage = () => {
  const { state } = useContext(AppContext);
  const {
    visits,
    uniqueVisitors,
    visitsCharts,
    uniqueVisitorsCharts,
    tableRows,
    onDateRangeChange,
    loading,
  } = useAnalytics({
    projectId: state.checkoutPageId,
    pageName: 'checkout-page',
  });

  return (
    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', height: '100%' }}>
      <Analytics
        visits={visits}
        uniqueVisitors={uniqueVisitors}
        visitsCharts={visitsCharts}
        uniqueVisitorsCharts={uniqueVisitorsCharts}
        tableRows={tableRows}
        onDateRangeChange={onDateRangeChange}
        isLoading={loading}
      />
    </Box>
  );
};

export default AnalyticsPage;
